import * as layouts from "layouts"
import * as routing from "brandguard/routing"
import * as bgapprovals from "brandguard/display/approval"

export function upload(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.text.approval.upload}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="text-brandguard-upload"
			>
				<bgapprovals.TextActiveLink imageUrlgen={routing.image.approval.upload} documentUrlgen={routing.document.approval.upload} videoUrlgen={routing.video.approval.upload} />
				<bgapprovals.navigation.TextsNav />
				<bgapprovals.texts.UploadDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function review(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.text.approval.review}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="text-brandguard-review"
			>
				<bgapprovals.TextActiveLink imageUrlgen={routing.image.approval.review} documentUrlgen={routing.document.approval.review} videoUrlgen={routing.video.approval.review} />
				<bgapprovals.navigation.TextsNav />
				<bgapprovals.texts.ReviewDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function approved(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.text.approval.approved}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="text-brandguard-approved"
			>
				<bgapprovals.TextActiveLink imageUrlgen={routing.image.approval.approved} documentUrlgen={routing.document.approval.approved} videoUrlgen={routing.video.approval.approved} />
				<bgapprovals.navigation.TextsNav />
				<bgapprovals.texts.ApprovedDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function rejected(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.text.approval.rejected}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="text-brandguard-rejected"
			>
				<bgapprovals.TextActiveLink imageUrlgen={routing.image.approval.rejected} documentUrlgen={routing.document.approval.rejected} videoUrlgen={routing.video.approval.rejected} />
				<bgapprovals.navigation.TextsNav />
				<bgapprovals.texts.RejectedDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}
